import React, { useEffect, useState } from 'react'; // Import React and Hooks
import { NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import md5 from 'md5'; // Import the md5 library
import { FaUserCircle } from 'react-icons/fa'; // Import the user icon from react-icons
// eslint-disable-next-line
import UAVSphere_logo from "../assets/images/UAVspherelogo.png";
import { authActions } from '_store';

export { Nav };

function Nav() {
    const auth = useSelector(x => x.auth.value);
    const dispatch = useDispatch();
    const logout = () => dispatch(authActions.logout());

    // Get user email from local storage
    const userEmail = JSON.parse(localStorage.getItem('auth'))?.user?.email || null;

    // Generate Gravatar URL
    const gravatarHash = userEmail ? md5(userEmail.trim().toLowerCase()) : '';
    const gravatarUrl = `https://www.gravatar.com/avatar/${gravatarHash}?d=404&r=g&s=40`;

    // State to determine if Gravatar is valid
    const [isGravatarValid, setIsGravatarValid] = useState(true);

    // Check if the Gravatar image loads successfully
    const checkGravatar = () => {
        const img = new Image();
        img.src = gravatarUrl;
        img.onload = () => setIsGravatarValid(true);
        img.onerror = () => setIsGravatarValid(false);
    };

    // Call checkGravatar when the component mounts or when gravatarUrl changes
    useEffect(() => {
        if (userEmail) {
            checkGravatar(); // Check the Gravatar image
        }
    }, [gravatarUrl, userEmail]); // Re-run if the gravatarUrl or userEmail changes

    // Only show nav when logged in
    if (!auth) return null;

    return (
<nav className="navbar navbar-expand navbar-dark bg-dark px-3" style={{ minHeight: '60px', height: '60px' }}>
            <div>
                <img src={require('../assets/images/UAVspherelogo.png')} alt="UAVSphere Logo" style={{ height: '40px' }} />
            </div>
            <div className="navbar-nav">
                <NavLink to="/home" className="nav-item nav-link">Dashboard</NavLink>
                <NavLink to="/leads" className="nav-item nav-link">Leads</NavLink>
                <NavLink to="/applyjobs" className="nav-item nav-link">Jobs</NavLink>
            </div>
            
            <div className="navbar-nav ms-auto d-flex align-items-center">
                {/* Show Gravatar image if valid or fallback to default icon */}
                {isGravatarValid ? (
                    <img 
                        src={gravatarUrl} 
                        alt="User Gravatar" 
                        className="rounded-circle" 
                        style={{ width: '50px', height: '50px' }} 
                    />
                ) : (
                    <FaUserCircle size={50} color="#fff" />
                )}
                <button onClick={logout} className="btn btn-link nav-item nav-link">Logout</button>
            </div>
        </nav>
    );
}
